(function (Cobalt) {
    var $ = jQuery;
    var CPJobs = /** @class */ (function () {
        function CPJobs() {
            CPJobs.BindJobSearch();
        }
        CPJobs.initialize = function () {
        };
        CPJobs.BindJobSearch = function () {
            $('#j-job-search').on('input', function () {
                var searchTerm = $(this).val();
                var rows = $('tr[data-job-name]');
                rows.each(function () {
                    var row = $(this);
                    if (row.data('job-name').toLowerCase().indexOf(searchTerm.toLowerCase()) <= -1) {
                        row.hide();
                    }
                    else {
                        row.show();
                    }
                });
            });
        };
        return CPJobs;
    }());
    Cobalt.CPJobs = CPJobs;
})(Cobalt || (window.Cobalt = {}));
$(document).ready(function () {
    var job = new Cobalt.CPJobs();
});


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.CPJobs.js